import React from "react";
import middleware from "./middlewares/middleware";
import AllBanner from "../component/sections/advertise/banner/AllBanner";
import AddBanner from "../component/sections/advertise/banner/AddBanner";
import AllNative from "../component/sections/advertise/native/AllNative";
import AddNative from "../component/sections/advertise/native/AddNative";
import EditNative from "../component/sections/advertise/native/EditNative";
import AllPush from "../component/sections/advertise/push/AllPush";
import EditBanner from "../component/sections/advertise/banner/EditBanner";
import AllBannerCustomer from "../component/sections/advertise/customer/banner/AllBanner";
import ViewBannerCustomer from "../component/sections/advertise/customer/banner/ViewBanner";
import routesManageAdvertise from "./manage-advertise";
import SelectBannerGenerator from "../component/sections/advertise/banner-generator/SelectBannerGenerator";

const advertiseRoutes = [
  {
    path: "/advertise/banner/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllBanner />,
        "AllBanner"
      );
    },
    exact: true,
  },
  {
    path: "/advertise/banner/add/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddBanner />,
        "AddBanner"
      );
    },
    exact: true,
  },
  {
    path: "/advertise/banner/edit/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditBanner />,
        "EditBanner"
      );
    },
    exact: true,
  },
  {
    path: "/advertise/banner-generator",
    render: () => {
      return middleware(
        ["isUserLogin"],
        <SelectBannerGenerator />,
        "SelectBannerGenerator"
      );
    },
    exact: true,
  },
  {
    path: "/advertise/native/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllNative />,
        "AllNative"
      );
    },
    exact: true,
  },
  {
    path: "/advertise/native/add/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddNative />,
        "AddNative"
      );
    },
    exact: true,
  },
  {
    path: "/advertise/native/edit/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditNative />,
        "EditNative"
      );
    },
    exact: true,
  },
  {
    path: "/advertise/push/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllPush />,
        "AllPush"
      );
    },
    exact: true,
  },
  {
    path: "/advertise/customer/banner/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllBannerCustomer />,
        "AllBannerCustomer"
      );
    },
    exact: true,
  },
  {
    path: "/advertise/customer/banner/view/:advertiseID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ViewBannerCustomer />,
        "ViewBannerCustomer"
      );
    },
    exact: true,
  },
  ...routesManageAdvertise,
];

export default advertiseRoutes;
